module.exports = __webpack_public_path__ + "img/icon_newwin.7d6777d8.svg";